<template>
    <div id="range" class="component">
        <div class="middle" style="margin-left: 10px;" @click="focusTextbox">
            <span class="pill pill-light pill-back" style="padding: 7px 8px 6px 10px">
                <input
                    ref="searchBox"
                    @keyup.escape="reset(true)"
                    @keyup.enter.prevent="searchIfValid"
                    v-model="searchText"
                    @keyup="searchIfValid"
                    @input="searchIfValid"
                    @paste="searchIfValid"
                    autocomplete="false"
                    type="search"
                    id="search" 
                    placeholder="Search"
                    autocapitalize="off"
                    autocorrect="off"
                >
                <i class="material-icons">search</i>
            </span>
        </div>

        <transition name="fade">
            <div 
                @click="reset" 
                v-show="resultsVisible" 
                id="background"
            ></div>
        </transition>

        <transition name="fade">
        <div v-show="resultsVisible" id="searchContainer">
            <transition name="fade">
                <div v-if="!isBusy" class="container-fluid" style="padding: 2rem 1rem 0.5rem;">
                    <div class="row">
                        <div class="col">
                            <pill-navigation
                                v-if="totalResults > 0"
                                :items="navItems"
                                :active-item-id="segment"
                                @change="changeSegment"
                                disable-links
                                theme="light"
                            ></pill-navigation>
                        </div>
                        <div class="col-1 text-right">
                            <span @click="reset" class="material-icons header-search-close">close</span>
                        </div>
                    </div>
                </div>
            </transition>

            <transition name="fade">
                <div v-if="!isBusy && totalResults > 0" style="padding: 0 1rem 1rem .25rem; height: calc(100% - 67px);  overflow-x:scroll" class="results">
                <div :style="{ height: '100%', width: resultsWidth + 'px' }">

                    <div v-if="(segment === 'all' || segment === 'vehicles') && results.vehicles.length > 0" class="search-col vehicle-col">
                        <h1>Vehicles</h1>
                        <div class="search-col-inner">
                            <table class="table table-auto">
                            <tbody>
                                <tr v-for="(vehicle, vehicleIndex) in results.vehicles">
                                    <td @click="$root.navigateTo('vehicles/%s/overview', [vehicle.id])" style="cursor: pointer;" :class="(results.contacts.length + results.bookings.length + vehicleIndex) === selectionIndex ? 'selected' : ''">
                                        <div class="container-fluid">
                                            <div class="row" style="margin-left: -30px; margin-right: -30px;">
                                                <div class="col-3 col-xl-4">
                                                    <vehicle-image :instance="vehicle"></vehicle-image>
                                                </div>
                                                <div class="col">
                                                    <div class="row">
                                                        <div class="col-8">
                                                            <vehicle-description :instance="vehicle" :show-location="true"></vehicle-description>
                                                            <span class="badge badge-primary" style="font-size: .8rem; display: inline-block; margin-top: .75rem;">{{ vehicle.life_cycle_status_label }}</span>
                                                            <span v-if="vehicle.key_number" class="badge badge-primary" style="font-size: .8rem; display: inline-block; margin-top: .75rem;">Key # {{ vehicle.key_number }}</span>
                                                        </div>
                                                        <div class="col" style="color: white;">
                                                            <vehicle-price
                                                                :instance="vehicle"
                                                                :vat-calculation-inclusive="!vehicle.use_commercial_pricing"
                                                                :show-monthly-price="false"
                                                                :show-vat-status="true"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        </div>
                    </div>

                    <div v-if="(segment === 'all' || segment === 'deals') && totalDealsLength" class="search-col">
                        <h1>Deals</h1>
                        <div class="search-col-inner">
                            <table class="table table-auto">
                            <tbody>
                                <tr v-for="(deal, dealIndex) in combinedDeals">
                                    <td colspan="2" @click="deal.vrm ? Bus.emit('showArchivedDeal', { deal }) : $root.navigateTo('deals/%s/edit', [deal.id])" style="cursor: pointer;" :class="(dealIndex) === selectionIndex ? 'selected' : ''">
                                        <div class="row align-items-center contact">
                                        <div class="col">
                                            <div style="color: #999;">#{{ deal.invoice_number ?? deal.id }}</div>
                                            <strong style="color: #fff;">{{ deal.contact.primary_display_as }}</strong>
                                            <div v-if="deal.vrm">
                                                <span class="registration small">{{ deal.vrm }}</span>
                                                <span class="truncate" style="color: #fff;max-width: 19vw;display: inline-block;vertical-align: middle;">{{ deal.manufacturer }} {{ deal.model }} {{ deal.derivative}}</span>
                                            </div>
                                            <div v-else>
                                                <span class="registration small">{{ vrm(deal.instance.vehicle) }}</span>
                                                <span class="truncate" style="color: #fff;max-width: 19vw;display: inline-block;vertical-align: middle;">{{ deal.instance.vehicle.manufacturer.name }} {{ deal.instance.vehicle.model.name }} {{ deal.instance.vehicle.derivative}}</span>
                                            </div>

                                        </div>
                                        <div class="col-3">
                                            <span :class="getDealBadgeClasses(deal)" style="font-size: 0.9em; padding: 6px 10px;">{{ deal.life_cycle_status_label ?? 'Archived'}}</span>
                                        </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        </div>
                    </div>

                    <div v-if="(segment === 'all' || segment === 'contacts') && results.contacts.length" class="search-col">
                        <h1>Contacts</h1>
                        <div class="search-col-inner">
                            <table class="table table-auto">
                            <tbody>
                                <tr v-for="(contact, contactIndex) in results.contacts">
                                    <td colspan="2" @click="$root.navigateTo('contacts/%s', [contact.id])" style="cursor: pointer;" :class="(contactIndex) === selectionIndex ? 'selected' : ''">
                                        <div class="row align-items-center contact">
                                        <div class="col-2">
                                            <avatar :contact="contact" :size="64"></avatar>
                                        </div>
                                        <div class="col">
                                            <strong style="color: #fff;">{{ contact.primary_display_as }}</strong>
                                            <dl style="color: #fff;">
                                                <dd v-if="contact.sage_reference">{{ contact.sage_reference.ref }}</dd>
                                                <dd v-if="contact.email">{{ contact.email }}</dd>
                                                <dd v-if="contact.primary_telephone">{{ contact.primary_telephone }}</dd>
                                                <dd v-if="contact.alternate_telephone">{{ contact.alternate_telephone }}</dd>
                                            </dl>
                                            <span style="font-size: .8rem; color: #fff;">{{ contact.formatted_address }}</span>
                                        </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        </div>
                    </div>

                    <div v-if="(segment === 'all' || segment === 'bookings') && results.bookings.length > 0" class="search-col">
                        <h1>Bookings</h1>
                        <div class="search-col-inner">
                            <table class="table table-auto">
                            <tbody>
                                <tr v-for="(booking, bookingIndex) in results.bookings">
                                    <td colspan="2" @click="$refs['bookingModal'].open(booking)" style="cursor: pointer;" :class="(results.contacts.length + bookingIndex) === selectionIndex ? 'selected' : ''">
                                        <div class="row align-items-center booking">
                                            <div class="col-3">
                                                <div v-if="booking.calendar_entry" class="calendar">
                                                    <div class="calendar-top">
                                                        {{ booking.calendar_entry.from | formatDate('MMM YY') }}
                                                    </div>
                                                    <div class="calendar-bottom">
                                                        {{ booking.calendar_entry.from | formatDate('D') }}
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div><contact-name-and-details style="font-weight: bold;" link-colour="#fff" :contact="booking.contact" /></div>
                                                <div class="text-white mb-1" style="font-size: .8rem;">{{ booking.description }}</div>
                                                <div>
                                                    <span class="registration small" style="margin-top: 0; display: inline-block;">{{ vrm(booking.instance.vehicle) }}</span>
                                                    <span style="display: inline-block; font-weight: bold;" class="text-white">{{ booking.instance.title }}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        </div>
                    </div>

                    <div v-if="(segment === 'all' || segment === 'invoices') && results.invoices.length > 0" class="search-col">
                        <h1>Invoices</h1>
                        <div class="search-col-inner">
                            <table class="table table-auto">
                            <tbody>
                                <tr v-for="(invoice, invoiceIndex) in results.invoices">
                                    <td colspan="2" @click="$refs.invoiceModal.open(invoice)" style="cursor: pointer;" :class="(results.invoices.length + invoiceIndex) === selectionIndex ? 'selected' : ''">
                                        <div class="row align-items-center booking">
                                            <div class="col" style="color: white;">
                                                <div style="font-weight: bold; font-size: 1rem;">#{{ invoice.id }} <span class="spacer">|</span> {{ invoice.contact.primary_display_as }} <span class="spacer">|</span> {{ invoice.tax_at | formatDate('D/M/Y') }} <span class="spacer">|</span> {{ invoice.gross | currency(2) }}</div>
                                                <div style="color: #ccc;">{{ invoice.description }}</div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        </div>
                    </div>

                    <div v-if="(segment === 'all' || segment === 'expenses') && results.expenses.length > 0" class="search-col">
                        <h1>Expenses</h1>
                        <div class="search-col-inner">
                            <table class="table table-auto">
                            <tbody>
                                <tr v-for="(expense, expenseIndex) in results.expenses">
                                    <td colspan="2" @click="$refs.expenseModal.open(expense)" style="cursor: pointer;" :class="(results.expenses.length + expenseIndex) === selectionIndex ? 'selected' : ''">
                                        <div class="row align-items-center booking">
                                            <div class="col" style="color: white;">
                                                <div style="font-weight: bold; font-size: 1rem;">#{{ expense.id }} <span class="spacer">|</span> <span v-if="expense.reference">{{ expense.reference }} <span class="spacer">|</span> </span>{{ expense.contact.primary_display_as }} <span class="spacer">|</span> {{ expense.tax_at | formatDate('D/M/Y') }} <span class="spacer">|</span> {{ expense.gross | currency(2) }}</div>
                                                <div style="color: #ccc;">{{ expense.description }}</div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        </div>
                    </div>
                </div>
            </div>
            </transition>

            <transition name="fade">
                <div v-show="isBusy||!isBusy && totalResults === 0" style="position: absolute; top: 50px; left: 0; right: 0; bottom: 0; display: flex; align-items: center;">
                    <div v-if="isBusy" style="flex:1;">
                        <cog-loader
                            ref="loader"
                            style="padding: 5rem 0;"
                            color="#ffffff"
                            :strings="['Finding your results', 'Bear with me', 'Shouldn\'t be much longer']"
                        ></cog-loader>
                    </div>
                    <div style="flex: 1; padding: 4.5rem 0;"  v-show="!isBusy && totalResults === 0" class="text-center">
                        <h1 style="font-weight: lighter;">Nothing found</h1>
                    </div>
                </div>
            </transition>
        </div>
    </transition>

        <invoice-modal
            ref="invoiceModal"
            style="color:#42526e"
            @saved="searchIfValid"
            @destroyed="searchIfValid"
        ></invoice-modal>

        <expense-modal
            ref="expenseModal"
            style="color:#42526e"
            @saved="searchIfValid"
            @destroyed="searchIfValid"
        ></expense-modal>

        <booking-modal
            ref="bookingModal"
            style="color:#42526e"
            @saved="searchIfValid"
            @destroyed="searchIfValid"
        ></booking-modal>
    </div>
</template>

<style lang="scss">

    .header-search-close {
        font-size: 3rem;
        position: absolute;
        right: 20px;
        top: -10px;
        cursor: pointer;

        &:hover { color: #ccc; }
    }

    .search-col {
        height:100%;
        width: 40vw;
        padding: 1rem;
        display: inline-block;

        h1 {
            font-size: .7rem;
            text-transform: uppercase;
            font-weight: bold;
        }

        .spacer {
            font-weight: normal; display: inline-block; padding: 0 .3rem;
            opacity: .5;
        }

        .search-col-inner {
            overflow-y: scroll;
            height:100%;
        }
    }

    #range {

        .booking {
            a, a:link, a:hover { color: #fff; }

            .calendar {
                text-align: center;

                .calendar-top {
                    background: #F3425F;
                    padding: .25rem;
                    color: #fff;
                    text-transform: uppercase;
                    font-size: .8rem;
                }

                .calendar-bottom {
                    background: #fff;
                    padding: .25rem;
                    font-size: 1.5rem;
                    font-weight: bold;
                }
            }
        }

        .contact {
            dl {
                margin-bottom: 0;
                font-size: .8rem;
                dd { 
                    display: inline; 
                    &:after { content: ' /'; color: rgba(255,255,255,0.4); }
                    &:last-of-type { &:after { display: none; }}
                }
            }
        }

        #background {
            background: rgba(255,255,255,0.75); 
            position: fixed; 
            top: 60px; bottom: 0; left:0; right: 0; 
            margin: 0;
        }

        #search {
            background: transparent; 
            border: none; 
            color: #fff;
            outline: none; 
            width: 155px;
        }

        #searchContainer {
            z-index: 10;
            background: rgba(57, 61, 86, .60);
            backdrop-filter: blur(3px);
            position: fixed; left: 0; right: 0;
            bottom: 0;
            top: 60px;
            margin: 0 !important;
            overflow: hidden; 
        }

        .fade-enter-active, .fade-leave-active {
          transition: opacity .5s
        }
        .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
          opacity: 0
        }

        .search-col {
            .table th {
                font-size: .7rem;
                text-transform: uppercase;
            }

            .table th, .table td {
                border-top: 1px solid rgba(236, 238, 239, 0.13);
                padding-left: .5rem
            }

            .table thead th {
                border: none;
            }

            .table tr:hover {
                background: rgba(0, 0, 0, 0.1)
            }
        }

        ::-webkit-scrollbar, ::-webkit-scrollbar-thumb, ::-webkit-scrollbar-corner {
            background: rgba(255,255,255, 0.1);
        }
        
        .results {
            td { 
                padding: 1rem; 

                &.selected { background: #ffffff20; }
            }
            .vehicle-image {
                figure { border-radius: 3px; background: transparent; }
            }
            .vehicle-description { 
                .vehicle-title, .vehicle-derivative { color: #fff; }
                .registration { color: #000; }
                .vehicle-description-location { color: #ccc; font-size: .8rem; margin-left: .25rem; }
            }
        }
    }
</style>

<script>
    import {vrm} from "../../filters/vehicle/vrm";
    import { ContactResource } from '../../classes/Api/Contact'
    import { VehicleInstanceResource } from '../../classes/Api/Vehicle'
    import { BookingResource } from "../../classes/Api/Booking"
    import CogLoader from '../elements/CogLoader'
    import VehiclePrice from '../elements/VehiclePrice'
    import BookingsSchedulerBodyCell from "../bookings/BookingsSchedulerBodyCell";
    import Filters from '../../filters'
    import Moment from 'moment'
    import VehicleImage from "../elements/VehicleImage";
    import {InvoiceResource} from "../../classes/Api/Invoice";
    import InvoiceModal from "../forms/InvoiceModal";
    import {ExpenseResource} from "../../classes/Api/Expense";
    import ExpenseModal from "../forms/ExpenseModal";
    import BookingModal from "../bookings/BookingModal";
    import {ArchivedDealResource} from "../../classes/Api/ArchivedDeal";
    import {DealLifeCycleStatuses, DealResource} from "../../classes/Api/Deal";
    import Bus from "../../events";

    export default {
        components: {
            InvoiceModal, ExpenseModal, BookingsSchedulerBodyCell,
            CogLoader, VehiclePrice, VehicleImage, BookingModal
        },
        filters: Filters,
        data() {
            return {
                Bus,
                searchText: '',
                resultsVisible: false,
                isBusy: false,
                selectionIndex: 0,
                segment: 'all',
                itemWidth: 1000,
                results: {
                    contacts: [],
                    vehicles: [],
                    bookings: [],
                    invoices: [],
                    expenses: [],
                    deals: [],
                    archived_deals: [],
                },
            }
        },
        mounted() {
            window.addEventListener('resize', () => {
                this.columnsResized()
            })
        },
        computed: {
            combinedDeals() {
                return this.results.deals.concat(this.results.archived_deals)
            },
            totalDealsLength() {
                return this.combinedDeals.length
            },
            resultsWidth() {
                return this.segment === 'all' && (this.itemWidth * (this.navItems.length - 1)) ||
                    this.itemWidth
            },
            totalResults() {
                return this.results.contacts.length +
                    this.results.vehicles.length +
                    this.results.bookings.length +
                    this.results.invoices.length +
                    this.results.deals.length +
                    this.results.archived_deals.length +
                    this.results.expenses.length;
            },
            navItems() {
                let items = [{
                    id: 'all',
                    label: 'All',
                    url: '#'
                }]

                if (this.results.vehicles.length) {
                    items.push({
                        id: 'vehicles',
                        label: 'Vehicles (' + this.results.vehicles.length + (this.results.vehicles.length >= 25 ? '+' : '') + ')',
                        url: '#'
                    })
                }

                if (this.results.contacts.length) {
                    items.push({
                        id: 'contacts',
                        label: 'Contacts (' + this.results.contacts.length + (this.results.contacts.length >= 25 ? '+' : '') + ')',
                        url: '#'
                    })
                }

                if (this.results.bookings.length) {
                    items.push({
                        id: 'bookings',
                        label: 'Bookings (' + this.results.bookings.length + (this.results.bookings.length >= 25 ? '+' : '') + ')',
                        url: '#'
                    })
                }

                if (this.results.invoices.length) {
                    items.push({
                        id: 'invoices',
                        label: 'Invoices (' + this.results.invoices.length + (this.results.invoices.length >= 25 ? '+' : '') + ')',
                        url: '#'
                    })
                }

                if (this.results.expenses.length) {
                    items.push({
                        id: 'expenses',
                        label: 'Expenses (' + this.results.expenses.length + (this.results.expenses.length >= 25 ? '+' : '') + ')',
                        url: '#'
                    })
                }

                if (this.totalDealsLength) {
                    items.push({
                        id: 'deals',
                        label: 'Deals (' + this.totalDealsLength + (this.totalDealsLength >= 25 ? '+' : '') + ')',
                        url: '#'
                    })
                }

                return items
            }
        },
        methods: {
            vrm,
            getDealBadgeClasses(deal) {
                const classes = ['badge']

                if (!deal.life_cycle_status_label) {
                    classes.push('badge-success')
                } else {
                    switch (deal.life_cycle_status)
                    {
                        case DealLifeCycleStatuses.COMPLETED:
                            classes.push('badge-success')
                            break;
                        case DealLifeCycleStatuses.REFUNDED:
                        case DealLifeCycleStatuses.CANCELLED:
                            classes.push('badge-danger')
                            break;
                        case DealLifeCycleStatuses.IN_PROGRESS:
                            classes.push('badge-warning')
                            break;
                        default:
                            classes.push('badge-seconday')
                            break;
                    }
                }

                return classes
            },
            resetResults() {
                this.results = {
                    contacts: [],
                    vehicles: [],
                    bookings: [],
                    invoices: [],
                    expenses: [],
                    deals: [],
                    archived_deals:[],
                }
            },
            columnsResized() {
                this.$nextTick(() => {
                    if (this.$el.querySelector('.search-col')) {
                        this.itemWidth = this.$el.querySelector('.search-col').getBoundingClientRect().width + 5
                    }
                })
            },
            changeSegment(segment) {
                this.segment = segment.id
            },
            focusTextbox() {
                this.$refs.searchBox.focus()
            },
            startOfWeekFor(booking) {
                return Moment(booking.calendar_entry.from)
                    .startOf('isoWeek')
                    .format('YYYY-MM-DD')
            },
            show(e) {
                document.querySelector('body, html').style.overflow = 'hidden';
                this.resultsVisible = true;
                this.isBusy = true;
                this.$nextTick(() => {
                    this.$refs['loader'].start()
                })
            },
            reset(hard = false) {
                this.resultsVisible = false; 
                this.selectionIndex = 0;

                if (hard) {
                    this.searchText = '';
                }

                document.querySelector('body, html').style.overflow = 'auto';

                this.resetResults()
            },
            navigate(e) {
                if ('ArrowDown' === e.key) {
                    if (this.selectionIndex < (this.totalResults - 1)) {
                        this.selectionIndex++;
                    }
                    e.preventDefault();
                    return;
                }

                if ('ArrowUp' === e.key) {
                    if (this.selectionIndex > 0) {
                        this.selectionIndex--;
                    }
                    e.preventDefault();
                    return;
                }

                if ('Enter' === e.key && (this.results.contacts.length > 0 || this.results.vehicles.length > 0)) {

                    if (this.selectionIndex < this.results.vehicles.length) {
                        let vehicle = this.results.vehicles[this.selectionIndex]
                        if (vehicle.id) {
                            this.$root.navigateTo('vehicles/%s/overview', [vehicle.id])
                        }
                    } else if (this.selectionIndex < (this.results.vehicles.length + this.results.contacts.length)) {
                        let contact = this.results.contacts[this.results.vehicles.length + this.selectionIndex]
                        if (contact.id) {
                            this.$root.navigateTo('contacts/%s', [contact.id])
                        }
                    } else if (this.selectionIndex < (this.results.vehicles.length + this.results.contacts.length + this.results.bookings.length)) {
                        let booking = this.results.bookings[this.results.vehicles.length - this.selectionIndex - this.results.contacts.length]
                        if (booking.id) {
                            this.$refs['bookingModal'].open(booking)
                        }
                    } else if (this.selectionIndex < (this.results.invoices.length + this.results.vehicles.length + this.results.contacts.length + this.results.bookings.length)) {
                        let invoice = this.results.invoices[this.selectionIndex - this.results.vehicles.length - this.results.contacts.length - this.results.bookings.length]
                        if (invoice.id) {
                            this.$refs['invoiceModal'].open(invoice)
                        }
                    } else if (this.selectionIndex < (this.results.expenses.length + this.results.invoices.length + this.results.vehicles.length + this.results.contacts.length + this.results.bookings.length)) {
                        let expense = this.results.expenses[this.selectionIndex - this.results.invoices.length - this.results.vehicles.length - this.results.contacts.length - this.results.bookings.length]
                        if (expense.id) {
                            this.$refs['expenseModal'].open(expense)
                        }
                    }

                    this.reset(true);
                    return;
                }
            },
            searchIfValid: _.debounce(function(e) {
                if (this.searchText.length >= 2 && (!e || !e.key || e.key.length === 1 || 'Backspace' === e.key || 'Enter' === e.key)) {
                    this.show();

                    return this.search(this.searchText);
                } else if (this.searchText.length < 2) {
                    this.reset()
                }
            }, 500),
            search(text) {
                this.segment = 'all'

                this.resetResults()

                VehicleInstanceResource.cancelCurrentRequest();
                ContactResource.cancelCurrentRequest();
                BookingResource.cancelCurrentRequest();
                InvoiceResource.cancelCurrentRequest();
                ExpenseResource.cancelCurrentRequest();
                ArchivedDealResource.cancelCurrentRequest();
                DealResource.cancelCurrentRequest();

                let contactCancelToken = ContactResource.createCancelToken()
                let instanceCancelToken = VehicleInstanceResource.createCancelToken()
                let bookingCancelToken = BookingResource.createCancelToken()
                let invoiceCancelToken = InvoiceResource.createCancelToken()
                let expenseCancelToken = ExpenseResource.createCancelToken()
                let archivedDealCancelToken = ArchivedDealResource.createCancelToken()
                let dealCancelToken = DealResource.createCancelToken()
                let completedCount = 0

                let timeout;

                let tryCompleting = () => {
                    completedCount++
                    
                    if (completedCount >= 2) {
                        clearTimeout(timeout)

                        timeout = setTimeout(() => {
                            this.isBusy = false

                            this.columnsResized()
                        }, 1000)
                    }
                }

                let handleError = (err) => {
                    tryCompleting();
                    if (!window.http.isCancel(err)) {
                        if (!err.response || err.response.status !== 403) {
                            handleApiError(err);
                        }
                    }
                }

                ContactResource.search(
                    text, 
                    null, 
                    { sort_order: 'id DESC' }, 
                    { cancelToken: contactCancelToken }
                ).then(response => 
                {
                    this.results.contacts = response.data;
                    tryCompleting();
                }).catch(handleError)

                BookingResource.search(
                    text,
                    { sort_order: 'calendarEntry.from DESC' },
                    { cancelToken: bookingCancelToken }
                ).then(response =>
                {
                    this.results.bookings = response.data;
                    tryCompleting();
                }).catch(handleError)

                InvoiceResource.search(
                    text,
                    { sort_order: 'tax_at DESC' },
                    { cancelToken: invoiceCancelToken }
                ).then(response =>
                {
                    this.results.invoices = response.data;
                    tryCompleting();
                }).catch(handleError)

                ExpenseResource.search(
                    text,
                    { sort_order: 'tax_at DESC' },
                    { cancelToken: expenseCancelToken }
                ).then(response =>
                {
                    this.results.expenses = response.data;
                    tryCompleting();
                }).catch(handleError)

                VehicleInstanceResource.search(
                    text, 
                    null, 
                    { with: 'images', sort_order: 'life_cycle_status ASC, id DESC' }, 
                    { cancelToken: instanceCancelToken }
                ).then(response => 
                {
                    this.results.vehicles = response.data;
                    tryCompleting();
                }).catch(handleError)

                if (window.marque.ui.features.deals.archived === true) {
                    ArchivedDealResource.search(
                        text,
                        {with: 'contact'},
                        {cancelToken: archivedDealCancelToken}
                    ).then(response => {
                        this.results.archived_deals = response.data;
                        tryCompleting();
                    }).catch(handleError)
                }

                // DealResource.search(
                //     text,
                //     { with: ['contact', 'instance'] },
                //     { cancelToken: dealCancelToken }
                //
                // ).then(response =>
                // {
                //     this.results.deals = response.data;
                //     tryCompleting();
                // }).catch(handleError)
            },
        }
    }
</script>